import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-8/12" }, "Verify your account", -1)
const _hoisted_2 = { class: "w-full align-middle mt-[50px] flex flex-col gap-6 bg-white shadow-base h-[25rem] rounded-3xl px-5 py-10" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "w-full flex flex-col items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { computed } from "vue"
  import { generateSchema } from "@/utils/validate"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useAccountStore } from "@/store/account"
  import * as jwt from "@/utils/jwt"

  import FormContainer from "@/components/template/formTemplate.vue"
  import WbTemplate from "@/components/account-creation/template.vue"
  import SixDigitContainer from "@/components/template/SixdigitCode.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyPage',
  setup(__props) {

  const authenticationStore = useAuthenticationStore()
  const accountStore = useAccountStore()

  const userEmail = computed(() => accountStore.email)

  const verification = computed({
    get: () => authenticationStore.verificationCode,
    set: (val) => {
      authenticationStore.setVerificationCode(val)
    },
  })

  const validationSchema = generateSchema([
    {
      name: "sixDigitCode",
      rule: "sixDigitCode",
    },
  ])

  const verify = () => {
    authenticationStore.setVerificationCode({ email: userEmail })
    authenticationStore.verifyCode(jwt.default.generateNBF())
  }

  const resendOTP = () => {
    authenticationStore.requestOTP(userEmail.value, jwt.default.generateNBF())
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(WbTemplate, null, {
    default: _withCtx(() => [
      _createVNode(FormContainer, {
        "validation-schema": _unref(validationSchema),
        class: "flex flex-col w-[25rem] items-center justify-center text-light-black",
        onValid: verify
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, "Please enter the 6 digit code sent to " + _toDisplayString(_unref(userEmail)), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(SixDigitContainer, {
                modelValue: _unref(verification).otp,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(verification).otp) = $event)),
                name: "sixDigitCode"
              }, null, 8, ["modelValue"]),
              _createElementVNode("p", { class: "text-center pt-5" }, [
                _createTextVNode("Didn’t receive an email? "),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-primary-violet underline",
                  onClick: resendOTP
                }, "Resend code.")
              ])
            ]),
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Continue")
              ]),
              _: 1
            }),
            _hoisted_5
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }))
}
}

})